import { InjectionToken } from '@angular/core';
import { EnvironmentType } from '../interfaces';

export interface I18nConfig {
  type: 'dashboard' | 'calculator' | 'governance';
  crowdinId: string;
  env: EnvironmentType;
}

export const I18N_CONFIG = new InjectionToken<I18nConfig>('I18N_CONFIG');